import { render, staticRenderFns } from "./BorrowerInformation.vue?vue&type=template&id=ec4d51a6&scoped=true"
import script from "./BorrowerInformation.vue?vue&type=script&lang=js"
export * from "./BorrowerInformation.vue?vue&type=script&lang=js"
import style0 from "./BorrowerInformation.vue?vue&type=style&index=0&id=ec4d51a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4d51a6",
  null
  
)

export default component.exports